import { useMemo } from 'react'

import { AlternativesQuestionModel } from '../../../domain/models'

import { SelectInput } from '..'

import * as S from './styles'

type SelectQuestionProps = {
  label: string
  options: AlternativesQuestionModel[]
  optionSelected: AlternativesQuestionModel
  order: number
  onChange: (opt: AlternativesQuestionModel) => void
}

const SelectQuestion = ({
  label,
  options,
  optionSelected,
  onChange,
  order
}: SelectQuestionProps) => {
  const optionsToSelect = useMemo(
    () =>
      options?.map((item) => {
        return {
          value: item?.cdAlternativa,
          label: item?.alternativa
        }
      }),
    [options]
  )

  return (
    <S.Wrapper>
      <S.Title>{label}</S.Title>
      <SelectInput
        name={`select-with-justification-${order}`}
        options={optionsToSelect}
        hasSelectOption={false}
        hasQuestionInput
        labelColor="#4f4f4f"
        onChange={(e) => {
          const selectedValue = optionsToSelect.find(
            (item) => item.value === Number(e.target.value) && item.label
          )

          onChange({
            cdAlternativa: Number(e.target.value),
            alternativa: selectedValue?.label || ''
          })
        }}
        defaultValue={optionSelected?.cdAlternativa}
      />
    </S.Wrapper>
  )
}

export default SelectQuestion
